// eslint-disable-next-line import/no-cycle
import { APIS, clients } from '@/core/clients';

const client = clients[APIS.SELF_SERVICE.name];
const storageApi = {
  getCampaignScreenshotNames(campaignId) {
    return client.get(`/storage/campaign-${campaignId}/files?bucketName=SCREENSHOT`)
      .then((response) => response.data);
  },
  getCampaignScreenshotImage(campaignId, fileName) {
    return client.get(`/storage/campaign-${campaignId}/file?bucketName=SCREENSHOT&fileName=${fileName}`)
      .then((response) => response.data);
  },
  downloadAnArchive(campaignId) {
    const config = { responseType: 'arraybuffer' };
    return client.get(`/storage/campaign-${campaignId}/archive?bucketName=SCREENSHOT`, config)
      .then((response) => response.data);
  },
  uploadCampaignScreenshot(payload) {
    const { formData } = payload;
    const config = {
      ...client.defaults,
      headers: {
        ...client.defaults.headers,
        'Content-Type': 'multipart/form-data',
      },
    };
    return client.post(`/storage/campaign-${payload.campaignId}/file?bucketName=SCREENSHOT`, formData, config)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },
  deleteCampaignScreenshot(campaignId, payload) {
    return client.delete(`/storage/campaign-${campaignId}/file?bucketName=SCREENSHOT`, { data: payload })
      .then((response) => response.data);
  },
};
export default storageApi;
